import styles from "@/styles/components/ProgressBar.module.css"

/**
 * How far through the flow a session is: a label, a percentage, an olive fill.
 *
 * The number is derived from `getProgress` over `activeRounds(config)` — a
 * session with the pains round switched off is not stuck at 86%. Nothing about
 * progress is stored.
 */

interface ProgressBarProps {
  /** Where the room is, e.g. "Set the Priorities". */
  label: string
  /** 0–100. */
  percent: number
}

export default function ProgressBar({ label, percent }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)))

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <span className={styles.label}>{label}</span>
        <span className={styles.percent}>{clamped}%</span>
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className={styles.fill} style={{ width: `${clamped}%` }} />
      </div>
    </div>
  )
}
